import React from 'react';
import styles from './DocButton.module.scss';
import { Loader } from '@mantine/core';

type Props = {
  leftIcon?: React.ReactNode,
  rightIcon?: React.ReactNode,
  failedIcon?: React.ReactNode,
  children: React.ReactNode,
  loading?: boolean,
  failed?: boolean,
  disabled?: boolean,
  href?: string,
  description?: string,
  button?: React.ReactNode,
}

function DocButton({ leftIcon, rightIcon, failedIcon, children, loading, failed, disabled, href, description, button }: Props) {

  if (loading) {
    return (
      <div className={styles.DocButton + " " + styles.loading}>
        {leftIcon && <div className={styles.leftIcon}>{leftIcon}</div>}
        <div className={styles.list}>
          <div className={styles.label}>{children}</div>
          {description && <div className={styles.description}>{description}</div>}
        </div>
        {rightIcon && !loading && <div className={styles.rightIcon}>{rightIcon}</div>}
        {loading && <Loader size={24} />}
      </div>
    );
  }

  if (failed) {
    return (
      <div className={styles.DocButton + " " + styles.loading}>
        {leftIcon && <div className={styles.leftIcon}>{leftIcon}</div>}
        <div className={styles.list}>
          <div className={styles.label}>{children}</div>
          {description && <div className={styles.description}>{description}</div>}
        </div>
        {rightIcon && !loading && <div className={styles.rightIcon}>{failedIcon}</div>}
        {loading && <Loader size={24} />}
      </div>
    );
  }

  if (disabled) {
    return (
      <div className={styles.DocButton + " " + styles.loading}>
        <div className={styles.list + " "+styles.disabled}>
          <div className={styles.label}>{children}</div>
          {description && <div className={styles.description}>{description}</div>}
        </div>
      </div>
    );
  }

  if (button) {
    return (
      <div className={styles.DocButton + " " + styles.loading}>
        {leftIcon && <div className={styles.leftIcon}>{leftIcon}</div>}
        <div className={styles.list}>
          <div className={styles.label}>{children}</div>
          {description && <div className={styles.description}>{description}</div>}
        </div>
        <div className={styles.rightIcon}>{button}</div>
      </div>
    );
  }

  return (
    <a href={href} target="_blank" rel="noreferrer" className={styles.DocButton}>
      {leftIcon && <div className={styles.leftIcon}>{leftIcon}</div>}
      <div className={styles.list}>
        <div className={styles.label}>{children}</div>
        {description && <div className={styles.description}>{description}</div>}
      </div>
      {rightIcon && !loading && <div className={styles.rightIcon}>{rightIcon}</div>}
      {loading && <Loader size={24} />}
    </a>
  );
}

export default DocButton;
